export default __webpack_public_path__ + "static/not-found-image-6296a874d1a29d5bb26a7240863f72ff.jpg";